import { useTimer } from "react-timer-hook";

const Timer = ({ durationInSeconds }) => {
  const expiryTimestamp = new Date();
  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + durationInSeconds);

  const { seconds } = useTimer({ expiryTimestamp });

  return (
    <div className="text-[#007BFF] text-base">
      <span>{seconds}</span>
    </div>
  );
};

export default Timer;
